export const locationSearch = () => {
    var searchButton = $('#search-submit');
    var locationInput = $('#location-input');
    var locationtypesSelect = $('#locationtypes-select');
    var keywordInput = $('#keyword-input');

    searchButton.on("click", function () {
        var params = {};
        if (locationInput.val()) {
            params.zip = encodeURIComponent(locationInput.val());
        }

        if (locationtypesSelect.val()) {
            params.type = locationtypesSelect.val()
        }

        if (keywordInput.val()) {
            params.keyword = keywordInput.val()
        }

        var redirectUrl = $('#hdn-redirecturl').val();
        if (redirectUrl) {
            if (!jQuery.isEmptyObject(params)) {
                redirectUrl += "?" + $.param(params);
            }

            window.location.href = redirectUrl;
        } else {
            console.log("Location Search Page is not set.");
        }
    });

	$('#location-input').on("focus", function() {
		$('#geo-button').show();
	});
	
	$('#location-input').on("blur", function() {
		setTimeout( () => $('#geo-button').hide(), 750);
	});

    $('#geo-button').on("click", function (e) {
		e.preventDefault();
        if ("geolocation" in navigator) {
            // check if geolocation is supported/enabled on current browser
            navigator.geolocation.getCurrentPosition(
                function success(position) {
                    getAddress(position.coords.latitude, position.coords.longitude);
                },
                function error(error_message) {
                    // for when getting location results in an error
                    console.error('An error has occured while retrieving location', error_message);
                }
            );
        } else {
            // geolocation is not supported
            console.log('geolocation is not enabled on this browser');
        }
    });

    function getAddress(latitude, longitude) {
        var GOOGLE_MAP_KEY = "AIzaSyDFMwCicJvIyvdz6cUv4xYGXui6iUi5xlY";

        $.ajax('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + latitude + ',' + longitude + '&key=' + GOOGLE_MAP_KEY)
            .then(
                function success(response) {
                    let addressComponents = response.results[0].address_components;
                    for (var i = 0; i < addressComponents.length; i++) {
                        if (addressComponents[i].types.includes('postal_code')) {
                            let zip = response.results[0].address_components[i].short_name;
                            locationInput.val(zip);
                        }
                    }
                },
                function fail(status) {
                    console.log('Request failed.  Returned status of', status)
                }
            )
    }
};